<template>
  <div>
    <AnimationBanner
      v-bind="$attrs"
      :model-value="modelValue"
    />
  </div>
</template>

<script setup lang="ts">
defineProps({
  modelValue: {
    type: Array as PropType<Banner[]>,
    required: true,
  },
})
</script>
